export const TimerIcon = ({ color = "#DBBE78", size = 33, ...props }) => (
    <svg
        width={size}
        height={size * (37 / 33)}
        viewBox="0 0 33 37"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M21.75 0.25H11.25V3.75H21.75V0.25Z" fill={color} />
        <path
            d="M28.8025 11.4325L31.2875 8.9475C30.535 8.055 29.7125 7.215 28.82 6.48L26.335 8.965C23.6225 6.795 20.21 5.5 16.5 5.5C7.8025 5.5 0.75 12.5525 0.75 21.25C0.75 29.9475 7.785 37 16.5 37C25.215 37 32.25 29.9475 32.25 21.25C32.25 17.54 30.955 14.1275 28.8025 11.4325ZM18.25 23H14.75V12.5H18.25V23Z"
            fill={color}
        />
    </svg>
);
